import { useReactiveVar } from '@apollo/client';
import { Dialog, DialogContent } from '@mui/material';
import React, { useCallback } from 'react';
import { leasingCommissionModalVar } from '../variables';
import EditComponent from './EditComponent';

const LeasingCommissionModalComponent = () => {
  const leasingCommissionModal = useReactiveVar(leasingCommissionModalVar);

  const close = useCallback((_, reason) => {
    if (reason === 'backdropClick') return true;
    leasingCommissionModalVar({ open: false });
  }, []);

  return (
    <Dialog open={leasingCommissionModal.open} fullWidth maxWidth='md' scroll={'body'} onClose={close} TransitionProps={{ exit: false }}>
      <DialogContent>{leasingCommissionModal.open && <EditComponent leasingCommission={leasingCommissionModal.item} />}</DialogContent>
    </Dialog>
  );
};

export default LeasingCommissionModalComponent;
